import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Slide from 'react-reveal/Slide';
import Zoom from 'react-reveal/Zoom';
import './Dentists.css';


function Dentists() {
    return (
        <div className='dentists my-4'>
            <Container>
                <Row> 
                    
                    <div className='dentists__text'>
                        <Slide bottom>
                            <h2 className='dentists__header mt-3' >Our Trusted Dentists</h2>
                            <p className='dentists__slogan'>The prettiest thing you can wear is your SMILE</p>
                            <p className='mb-3'>
                                We Serve The Prettiest Smiles And Make You Look Your Best While At It.
                            </p>
                        </Slide>
                    </div>


                    
                    
                </Row>
                <Row className='d-flex align-items-center justify-content-center'>
                    

                    <Col className="dentist_1 my-4" sm={12} lg={3}  md={6}>
                        <Zoom bottom>
                            <Card>
                                {/* holder.js/100px160 */}
                                <Card.Img fluid ={true ? true : undefined} variant="top"   src="images/majiwa.jpg" />
                                <Card.Body>
                                    <Card.Title className='card__text'>Dr.Gideon Majiwa</Card.Title>
                                    <Card.Text className='card__text'>
                                        <p>Bachelor of Dental Surgery</p>
                                        <p>University Of Nairobi</p>
                                        <p>Certificate in Orthodontics , Dental Aptitude College</p>
                                    </Card.Text>
                                </Card.Body>
                                <Card.Footer className="card__footer">
                            
                                </Card.Footer>
                            </Card>
                        </Zoom>
                    </Col>


                    <Col className='dentist_2 my-4' sm={12} lg={3}  md={6}>
                        <Zoom top>
                            <Card>
                                <Card.Img  variant="top" src="images/akwom.jpg"  fluid />
                                <Card.Body>
                                    <Card.Title className='card__text'>Dr.Patrick Akuom Onyango</Card.Title>
                                    <Card.Text className='card__text'>
                                        <p>Bachelor of Dental Surgery</p>
                                        <p>University Of Nairobi</p>
                                        
                                    </Card.Text>
                                </Card.Body>
                                <Card.Footer className="card__footer">
                                
                                </Card.Footer>
                        
                            </Card>
                        </Zoom>
                    </Col>

                

                    
                </Row>
            </Container>
            
        </div>
    );
}

export default Dentists;
